export default __webpack_public_path__ + "static/media/Broadform-homeowners-insurance-policy-2025.9011cdf9.pdf";